/**
 * Created by Victor Rojo on 7/11/19.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';

import {ProductTank, Tank} from './Tank';

@Injectable()
export class TankService{

  private basePath = "api/v1/";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  getProductTanks(iPlaceIds:string): Promise<any>{
    let url = this.basePath + "product-tank";
    let params = new HttpParams();
    params = params.append('iPlaceId', iPlaceIds);
    return this.http.get(url, { params: params })
      .toPromise()
      .then( res => res as ProductTank[])
      .catch( error => this.errorHandler(error) );
  }

  getTanks(iPlaceIds: string): Promise<any> {
    let url = this.basePath + "tanks";
    let params = new HttpParams();
    params = params.append('iPlaceIds', iPlaceIds);
    return this.http.get(url, { params: params })
      .toPromise()
      .then( res => res as Tank[])
      .catch( error => this.errorHandler(error) );
  }

}
